import { apiGet, apiSend } from './client'
import type { Dashboard, WidgetPayload, WidgetPlacement } from './types'

export function fetchDashboard(signal?: AbortSignal): Promise<Dashboard> {
  return apiGet<Dashboard>('/dashboard', { signal })
}

export function saveDashboard(layout: WidgetPlacement[]): Promise<Dashboard | null> {
  return apiSend<Dashboard>('/dashboard', 'PUT', { layout })
}

/**
 * Each widget fetches its own data, so one slow query cannot hold up the whole
 * page and a single widget can refresh without reloading the rest.
 */
export function fetchWidgetData<T>(widgetId: string, signal?: AbortSignal): Promise<WidgetPayload<T>> {
  return apiGet<WidgetPayload<T>>(`/widget/${widgetId}/data`, { signal })
}
